import { render, staticRenderFns } from "./FormPromptGate.vue?vue&type=template&id=b1106a96"
import script from "./FormPromptGate.vue?vue&type=script&lang=js"
export * from "./FormPromptGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports